import { configureStore } from "@reduxjs/toolkit";
import cameraReducer from "./reducers/CameraReducer";
import authReducer from "./reducers/AuthReducer";

export const Store = configureStore({
  reducer: {
    camera: cameraReducer,
    auth: authReducer,
  },
});

/* "C:\Program Files\Google\Chrome\Application\chrome.exe" --disable-web-security --user-data-dir="C:/ChromeDevSession"
 */